var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import { Label } from "./Label";
















const Select = /*#__PURE__*/React.forwardRef(
  (
  {
    id,
    label,
    options,
    value,
    disabled,
    hideLabel,
    hasErrors,
    className,
    name = '',
    onChange = () => {},
    onBlur = () => {}
  },
  ref) =>
  {
    const fieldStyles = hasErrors ?
    'border-error-300 focus:border-error-500 focus:ring-error-500 border-2 text-error-900' :
    'border-gray-300 border text-gray-900';

    return /*#__PURE__*/(
      _jsx("div", { className: className }, void 0, /*#__PURE__*/
      _jsx("div", { className: "relative w-full" }, void 0, /*#__PURE__*/
      _jsx(Label, { htmlFor: id, hideLabel: hideLabel, hasErrors: Boolean(hasErrors) }, void 0,
      label
      ), /*#__PURE__*/
      React.createElement("select", {
        className: `${fieldStyles} disabled:text-gray-500 rounded-lg bg-gray-50 block flex-1 w-full text-sm p-2.5`,
        id: id,
        disabled: disabled,
        ref: ref,
        name: name,
        onBlur: onBlur,
        onChange: onChange,
        value: value },

      options.map(({ key, value: optionValue, label: optionLabel }) => /*#__PURE__*/
      _jsx("option", { value: optionValue }, key || optionValue,
      optionLabel || optionValue
      )
      )
      )
      )
      ));

  }
);


export { Select };